import { domAnimation, m } from 'framer-motion';
import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';

import FramerMotion from '~/components/FramerMotion';
import ProductNotificationButton from '~/components/ProductNotificationButton';
import useHasScrolledPast from '~/hooks/useHasScrolledPast';
import usePageData from '~/hooks/usePageData';

type Props = {
  hideOnElementRef: React.RefObject<HTMLDivElement>;
  stockListing: AffiliateStockListing;
};

const StickyCta = ({ stockListing, hideOnElementRef }: Props) => {
  const product = usePageData<CapiProductPage>();

  const hideSticky = useHasScrolledPast(hideOnElementRef);

  return (
    <FramerMotion feature={domAnimation}>
      <m.div
        data-cy="sticky-cta"
        initial={false}
        animate={hideSticky ? 'hidden' : 'visible'}
        variants={{
          hidden: { opacity: 0, y: 100 },
          visible: { opacity: 1, y: 0 }
        }}
        transition={{ duration: 0.25, ease: 'easeInOut' }}
        className="fixed -bottom-0.5 left-0 z-10 flex w-full items-stretch justify-center gap-2 rounded-t-md bg-black p-4 shadow lg:hidden"
      >
        <div className="grow">
          {product.allow_user_notifications && (
            <ProductNotificationButton
              product={{
                affiliateName: stockListing.affiliate.name,
                id: product.product_id,
                image: product.gallery[0],
                legacyId: product.legacy_id,
                name: product.name,
                price: product.price.regular
              }}
              className="h-12"
              pagePosition="WTB"
              mode="dark"
              buttonStyle="normal"
            />
          )}
        </div>
      </m.div>
    </FramerMotion>
  );
};

export default StickyCta;
